<template>
  <ul>
    <MenuCategoryItem
      v-for="category in getCategories"
      :key="category.code"
      :category="category"
      @close-mobile-menu="$emit('close-mobile-menu')"
    />
  </ul>
</template>

<script setup>
import { storeToRefs } from "pinia"

import MenuCategoryItem from "./MenuCategoryItem.vue"

// import { theme } from "@/services/getSiteTheme"
import { useCategoriesStore } from "@/stores/categoriesStore"

const { getCategories } = storeToRefs(useCategoriesStore)

defineEmits({
  "close-mobile-menu": null,
})
</script>

<style lang="scss" scoped></style>
